module.exports = __webpack_public_path__ + "static/media/jeddah.d6e5dff4.png";